<script setup lang="ts">
  import { useFlowConfigStore } from '@/store/flow-config.store'

  const store = useFlowConfigStore()
</script>

<template>
  <div class="pages">
    <div
      v-for="(page, index) in store.config?.pages"
      :key="page.id"
      class="page"
      :class="{ 'page-active': store.currentPage === index }"
      @click="store.currentPage = index"
    >
      {{ index + 1 }}
    </div>
  </div>
</template>

<style scoped lang="css">
  .pages {
    display: flex;
    flex-direction: row;
    gap: var(--spacing-s);
  }

  .page {
    background-color: var(--colours-grey-1);
    height: 2.5rem;
    width: 1.5rem;
    text-align: center;
    align-content: center;
    border-radius: 0.25rem;
    cursor: pointer;
  }

  .page-active {
    color: var(--colours-brand-colour-1);
    font-weight: bold;
    border: 1px solid var(--colours-brand-colour-1);
    font-size: 1rem;
    box-shadow: 0 0 0 2px var(--colours-brand-colour-1);
  }
</style>
